import { render, staticRenderFns } from "./TestTutorialsPartFour.vue?vue&type=template&id=10b399a3&scoped=true&"
import script from "./TestTutorialsPartFour.vue?vue&type=script&lang=js&"
export * from "./TestTutorialsPartFour.vue?vue&type=script&lang=js&"
import style0 from "./TestTutorialsPartFour.vue?vue&type=style&index=0&id=10b399a3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b399a3",
  null
  
)

export default component.exports